import React from 'react';
import PropTypes from 'prop-types';

import CouponSelector from '../../Upgrade/CouponSelector';
import { Plans } from '../../constants';
import './styles.scss';
import usePriceCalculator from '../../../hooks/usePriceCalculator';

const Coupons = ({
  membership, couponsApplied, couponError, handleRemoveCoupon,
  couponCode, handleApplyCoupon, getCouponContentKey, couponDiscount,
}) => {
  const planKey = membership === Plans.SEASONAL ? 'seasonalPlan' : 'annualPlan';
  const subscriptionCost = Number(getCouponContentKey(`${planKey}.priceDetail.subscription.value`, '0.00'));
  const { shipping, tax, total } = usePriceCalculator(membership, subscriptionCost, couponDiscount);

  return (
    <section className="coupons">
      <div className="coupon-divider" style={{ margin: '0 0 9px 0' }} />
      <div className="subscription-container">
        <div className="fee">
          <h4>
            {getCouponContentKey(`${planKey}.priceDetail.subscription.description`, '') }
          </h4>
          <span>{subscriptionCost}</span>
        </div>
        <span className="coupons-text">{getCouponContentKey(`${planKey}.priceDetail.subscription.detail`, '')}</span>
      </div>
      <div className="coupon-divider" style={{ margin: '7px 0 11px 0' }} />
      <CouponSelector
        plan={membership}
        onApplyCoupon={handleApplyCoupon}
        onRemoveCoupon={handleRemoveCoupon}
        initialCouponCode={couponCode}
        error={couponError}
        couponsApplied={couponsApplied}
      />
      <div className="tax">
        <span className="coupons-text">{getCouponContentKey(`${planKey}.priceDetail.promo.description`, '')}</span>
        <span className="coupons-highlight-text">
          {couponDiscount}
        </span>
      </div>
      <div className="shipping">
        <span className="coupons-text">{getCouponContentKey(`${planKey}.priceDetail.shipping.description`, '')}</span>
        <span className="coupons-highlight-text">
          {shipping}
        </span>
      </div>
      <div className="tax">
        <span className="coupons-text">{getCouponContentKey(`${planKey}.priceDetail.tax.description`, '')}</span>
        <span className="coupons-highlight-text">
          {tax}
        </span>
      </div>
      <div className="total">
        <span className="coupons-text">{getCouponContentKey(`${planKey}.priceDetail.total.description`, '')}</span>
        <span className="coupons-highlight-text">
          {total}
        </span>
      </div>
    </section>
  );
};

Coupons.defaultProps = {
  membership: '',
};

Coupons.propTypes = {
  membership: PropTypes.string,
};

Coupons.displayName = 'Coupons';

export default Coupons;
